var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.analyticReport)?_c('div',[_c('MonthBrandAnalyticsReport',_vm._b({attrs:{"id":"monthly-report"}},'MonthBrandAnalyticsReport',_vm.analyticsSummary,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }